module.exports = "/assets/data/6d53af699794140db588fb78eb71c665-BS5.data.json";